import * as yup from 'yup';

/**
 * Creates validation schema for Approval Templates
 * Based on the Prisma ApprovalTemplate model structure
 */
export const createApprovalTemplatesValidationSchema = () => {
  return yup.object().shape({
    // Basic Information
    name: yup
      .string()
      .required('Template name is required')
      .min(3, 'Template name must be at least 3 characters')
      .max(255, 'Template name must not exceed 255 characters'),

    description: yup
      .string()
      .max(2000, 'Description must not exceed 2000 characters'),

    // Template Configuration
    entityTypeId: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === '' || originalValue === null ? null : Number(value);
      }),

    priorityId: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === '' || originalValue === null ? null : Number(value);
      }),

    approvalType: yup
      .string()
      .required('Approval type is required')
      .oneOf(['single', 'sequential', 'parallel', 'any_one', 'review_approval'], 
        'Invalid approval type'),

    workflowType: yup
      .string()
      .required('Workflow type is required')
      .oneOf(['review', 'approval', 'review_approval'], 
        'Invalid workflow type'),

    // Status
    isActive: yup
      .boolean()
      .default(true),

    // Steps validation would be handled separately if needed
    steps: yup
      .array()
      .of(
        yup.object().shape({
          stepNumber: yup.number().required(),
          stepName: yup.string().required(),
          approverType: yup.string().oneOf(['user', 'role', 'department']).required(),
          approverId: yup.number().nullable(),
          stepType: yup.string().oneOf(['approval', 'review']).default('approval'),
          isRequired: yup.boolean().default(true),
          canDelegate: yup.boolean().default(true),
          escalationDays: yup.number().default(7)
        })
      )
      .nullable()
  });
};

